import { useEffect, useRef, useState } from 'react'

type UseElementVisibleOptions = {
  threshold?: number
  everyInteraction?: boolean
}

export const useElementVisible = ({ threshold = 0.3, everyInteraction = false }: UseElementVisibleOptions = {}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          if (!everyInteraction) observer.unobserve(entry.target)
        } else if (everyInteraction) setIsVisible(false)
      },
      { threshold }
    )

    observer.observe(el)

    return () => observer.disconnect()
  }, [threshold, everyInteraction])

  return { ref, isVisible }
}
